import ImageComponent from '@components/utils/image';
import { usePanelHistoryContext } from '@context/panel-history';
import { useRightPanelContext } from '@context/right-section';
import { Suspense, useEffect, useMemo } from 'react';

import logo from '../../assets/images/logo.svg';
import RightPanel from '../utils/right-panel';
import { rightSectionComponentMap } from './right-section-component-map';

const GlobalRightSection = () => {
	const rightPanel = useRightPanelContext();

	const panelHistoryProps = usePanelHistoryContext();

	const { current: currentAction, goTo } = panelHistoryProps;

	// Watch rightPanel.action and push to panel history if it's a new entry
	useEffect(() => {
		if (
			rightPanel?.action &&
			(rightPanel.action.component !== currentAction?.action.component || rightPanel.action.type !== currentAction.action.type)
		) {
			goTo(rightPanel);
		}
	}, [rightPanel?.action]);

	useEffect(() => {
		if (currentAction?.action.component) {
			const componentEntry = rightSectionComponentMap[currentAction.action.component]?.find((entry) =>
				entry.action.includes(currentAction?.action.type)
			);
			componentEntry?.component?.preload?.();
		}
	}, [currentAction?.action.component, currentAction?.action.type]);

	useEffect(() => {
		if (!rightPanel.openSection) {
			panelHistoryProps.reset();
			sessionStorage.clear();
		}
	}, [rightPanel.openSection]);

	const Component = useMemo(() => {
		if (!currentAction?.action.component || !currentAction?.action.type) return null;

		const { component: path, type } = currentAction.action;

		const componentEntry = rightSectionComponentMap[path]?.find((entry) => entry.action.includes(type));

		if (!componentEntry) {
			console.error(`Component not found for path: ${path}, type: ${type}`);
			return null; // Or a fallback component
		}

		return componentEntry.component;
	}, [currentAction?.action.component, currentAction?.action.type]);

	if (!Component) return null;

	return (
		<RightPanel panelHistoryProps={panelHistoryProps}>
			<Suspense
				fallback={
					<div
						style={{ width: '100%', height: '100vh' }}
						className='f-column text-center align-items-center justify-content-center'
					>
						<ImageComponent
							src={logo}
							alt='logo'
							width='100px'
						/>
					</div>
				}
			>
				{Component ? <Component /> : null}
			</Suspense>
		</RightPanel>
	);
};

export default GlobalRightSection;
